export class QuoteStates {
  static FINAL = 'FINAL'
  static DRAFT = 'DRAFT'
  static REJECTED = 'REJECTED'
}
